exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faqs .question{display:block}.faqs .question .button-group{position:relative;top:-5px}.faqs .card--question{display:block;color:inherit;font-weight:400;cursor:pointer;text-decoration:none}.faqs .card--question:hover{background:#f9f9f9}.faqs .card--question i.fa{margin-right:.5rem;font-size:1rem;color:#005aaa}.faqs .card--answer{background:#f9f9f9;border-top:1px solid #d9d9d9}.faqs .card--answer :last-child,.faqs .card--answer figure{margin-bottom:0}.faqs .card--answer .attachment__caption{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/FAQ.vue
// module id = 426
// module chunks = 0